module.exports = __webpack_public_path__ + "img/resource-tech-image-11.ff36c25c.jpg";